import http from './http'

export default {
    getComment:function(param){
        return http.get('app/comment.php',{
            m:'comment',
            ac:'get_comment_list',
            v:'1.0',
            ...param
        })
    }
}